import(/* webpackMode: "eager" */ "/codebuild/output/src1355440236/src/src/app/global-error.tsx");
